import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Account } from '../../../../../domain/auth/model/account';

@Component({
  selector: 'app-logged-user-badge',
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './logged-user-badge.component.html',
  styleUrl: './logged-user-badge.component.scss',
})
export class LoggedUserBadgeComponent {
  @Input() user: Account;

  public get userInitials(): string {
    return (
      this.user.firstName && this.user.lastName
        ? this.user.firstName[0] + this.user.lastName[0]
        : this.user.firstName
          ? this.user.firstName[0]
          : this.user.email[0]
    ).toUpperCase();
  }

  public get userName(): string {
    if (!this.user.firstName) {
      return this.user.email;
    }
    return (
      this.user.firstName.charAt(0).toUpperCase() + this.user.firstName.slice(1)
    );
  }
}
